export const GET_PAYMENT = "GET_PAYMENT"
export const GET_PAYMENT_STATUS = "GET_PAYMENT_STATUS"
export const UPDATE_STATUS = "UPDATE_STATUS"
